import Vue from 'vue'
import { workOrderService } from '../../services'
import saveAs from 'file-saver'

export class WorkOrderBase {
  constructor () {
    this.state = {
      all: {
        filterInitialized: false,
        loading: true,
        saving: false,
        items: [],
        filter: {},
        meta: {},
        currentPage: 1
      }
    }
  }

  actions () {
    const that = this
    return {
      initialize ({ commit }) {
        commit('initialize')
      },

      resetFilter ({ commit }) {
        commit('resetFilter')
      },

      getListData ({ commit }) {
        commit('getListDataRequest')
        workOrderService.getListData(that.state.all.filter, that.state.all.currentPage)
          .then(
            data => {
              commit('getListDataSuccess', data.result)
            }
          )
      },

      createWorkOrdersFromDeliveryTemplate ({ commit, dispatch }, data) {
        return workOrderService.createWorkOrdersFromDeliveryTemplate(data)
          .then(data => {
            commit('createWorkOrdersFromDeliveryTemplateSuccess')
            dispatch('getListData')
            return data.result
          })
          .catch(error => {
            commit('createWorkOrdersFromDeliveryTemplateError', error)
            return Promise.reject(error)
          })
      },

      setWorkOrderStatusForList ({ commit, dispatch }, data) {
        return workOrderService.setWorkOrderStatusForList(data)
          .then(data => {
            commit('setWorkOrderStatusForListSuccess')
            dispatch('getListData')
            return data.result
          })
          .catch(error => {
            commit('setWorkOrderStatusForListError', error)
            return Promise.reject(error)
          })
      },

      exportToExcel ({ commit }, { projectCode, filter, template }) {
        let templateString
        if (template === 'quotation') {
          templateString = 'offert'
        } else if (template === 'detailed') {
          templateString = 'detaljerad'
        }

        return workOrderService.exportToExcel(filter, template)
          .then(response => {
            var blob = new Blob([response.data])
            saveAs(blob, `${projectCode} - Insatser (${templateString}).xlsx`)
            commit('exportToExcelSuccess')
          })
          .catch(error => {
            console.error(error)
            commit('exportToExcelError')
          })
      },

      containsStatusStarted ({ commit }, projectId) {
        return workOrderService.containsStatusStarted(projectId)
          .then(data => {
            return data.result.containsStatusStarted
          })
      },

      getById ({ commit }, id) {
        return workOrderService.getById(id)
          .then(data => {
            return data.result
          })
      },

      getEmptyWorkOrder ({ commit, dispatch }, projectCode) {
        return workOrderService.getEmptyWorkOrder(projectCode)
          .then(data => {
            return data.result
          })
      },

      create ({ commit, dispatch }, workOrder) {
        commit('startSave')
        return workOrderService.create(workOrder)
          .then(workOrder => {
            commit('endSave')
            dispatch('getListData')
            commit('createSuccess', workOrder.result)
            return workOrder.result
          }).catch(error => {
            commit('endSave')
            commit('createFailure')
            return Promise.reject(error)
          })
      },

      update ({ commit, dispatch }, workOrder) {
        commit('startSave')
        return workOrderService.update(workOrder)
          .then(workOrder => {
            commit('endSave')
            commit('updateSuccess', workOrder.result)
            return workOrder.result
          }).catch(error => {
            commit('endSave')
            commit('updateFailure')
            return Promise.reject(error)
          })
      },

      delete ({ commit }, id) {
        commit('startSave')
        commit('deleteRequest', id)
        workOrderService.delete(id)
          .then(workOrder => {
            commit('endSave')
            commit('deleteSuccess', id)
          })
      }
    }
  }

  getters () {
    return {
      isFilterChanged: state => (route) => {
        // Page should not be considered when comparing
        const currentFilter = Object.assign({}, state.all.filter)
        const defaultFilter = Object.assign({}, state.all.defaultFilter)

        currentFilter.page = null
        defaultFilter.page = null

        return !Vue.lodash.isEqual(currentFilter, defaultFilter)
      },

      getStatusOptions: state => {
        return [
          {
            value: 'Quoted',
            text: 'Offererad'
          }, {
            value: 'Planned',
            text: 'Planerad'
          }, {
            value: 'Started',
            text: 'Pågående'
          }, {
            value: 'Registered',
            text: 'Registrerad'
          }, {
            value: 'Invoiced',
            text: 'Fakturerad'
          }, {
            value: 'Cancelled',
            text: 'Makulerad'
          }
        ]
      }
    }
  }

  mutations () {
    const ret = {
      resetFilter (state) {
        state.all.currentPage = 1
        state.all.filter = Object.assign({}, state.all.defaultFilter)
      },

      initialize (state) {
        if (!state.all.filterInitialized) {
          ret.resetFilter(state)
          state.all.filterInitialized = true
        }
      },

      startSave (state) {
        state.all.saving = true
      },

      endSave (state) {
        setTimeout(() => {
          state.all.saving = false
        }, 200)
      },

      // Get all
      getListDataRequest (state) {
        state.all.loading = true
      },

      getListDataSuccess (state, data) {
        state.all.items = data.items
        state.all.meta = data.meta
        state.all.loading = false
      },

      getListDataFailure (state, error) {
        state.all.error = error
        state.all.loading = false
      },

      // Create
      createSuccess (state, updatedContact) {
        /*
        state.all.items = state.all.items.map(contact =>
          contact.contactId === updatedcontact.contactId ? updatedcontact : contact
        )
        */
        Vue.prototype.$toast('Insats skapad', 'success')
      },
      createFailure (state, error) {
        Vue.prototype.$toast('Kunde inte skapa insats', 'error')
      },

      // Update
      updateSuccess (state, updatedWorkOrder) {
        state.all.items = state.all.items.map(workOrder =>
          workOrder.workOrderId === updatedWorkOrder.workOrderId ? updatedWorkOrder : workOrder
        )

        Vue.prototype.$toast('Insats uppdaterad', 'success')
      },
      updateFailure (state) {
        Vue.prototype.$toast('Kunde inte uppdatera insatsen', 'error')
      },

      // Delete
      deleteRequest (state, id) {
        // add 'deleting:true' property to contact being deleted
        state.all.items = state.all.items.map(workOrder =>
          workOrder.contactId === id
            ? { ...workOrder, deleting: true }
            : workOrder
        )
      },

      deleteSuccess (state, id) {
        // remove deleted workorder from state
        state.all.items = state.all.items.filter(workOrder => workOrder.workOrderId !== id)
      },

      createWorkOrdersFromDeliveryTemplateSuccess (state) {
        Vue.prototype.$toast('Leverans skapad', 'success')
      },

      createWorkOrdersFromDeliveryTemplateError (state, error) {
        Vue.prototype.$toast('Leverans kunde inte skapas', 'error')
        console.error(error)
      },

      setWorkOrderStatusForListSuccess (state) {
        Vue.prototype.$toast('Status uppdaterad', 'success')
      },

      setWorkOrderStatusForListError (state, error) {
        Vue.prototype.$toast('Kunde inte uppdatera status', 'error')
        console.error(error)
      },

      exportToExcelSuccess (state, error) {
        Vue.prototype.$toast('Export klar', 'success')
        console.error(error)
      },

      exportToExcelError (state, error) {
        Vue.prototype.$toast('Kunde inte exportera', 'error')
        console.error(error)
      }
    }

    return ret
  }
}



// WEBPACK FOOTER //
// ./src/store/base-classes/work-order-base.js